import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setDrawingError,
  triggerLayoutRender
} from '../redux/actions';
import Diagram from '../components/Diagram';

const Drawing = () => {

  const dispatch = useDispatch();
  const layout = useSelector(state => state.layout);
  const drawing = useSelector(state => state.drawing);

  const handleGenerateClick = async () => {
    dispatch(triggerLayoutRender());
  }

  return <div className='flex flex-col'>

    <button
      id="generate" data-cy="generate"
      className={layout.error || drawing.inProgress ? "opacity-50 cursor-not-allowed" : ""}
      disabled={layout.error || drawing.inProgress ? true : false}
      onClick={handleGenerateClick}
    >Generate SVG</button>

    <input
      type="text"
      id="drawingError" data-cy="drawing-error"
      className="bg-gray-200 p-2 rounded-md"
      disabled
      value={drawing.error}
    />

    <Diagram />

  </div>

};

export default Drawing;